import React from "react";
import ReactDOM from "react-dom";
import "assets/css/lms-design.css";
import "./i18n";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme.js";
import { AuthProvider } from "contexts/AuthContext";
import ProtectedRoute from "components/ProtectedRoute";

ReactDOM.render(
  <ChakraProvider theme={theme} resetCss={false} position="relative">
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <Route path={`/auth`} component={AuthLayout} />
          <Route path={`/admin`}>
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          </Route>
          <Redirect from={`/`} to="/auth/signin" />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  </ChakraProvider>,
  document.getElementById("root")
);

if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("Tenant PWA ServiceWorker registration failed: ", err);
    });
  });
}
